export default __webpack_public_path__ + "static/media/pgmico(23).c0924a7e.png";